import { useQuery } from 'react-query';

import { ManagerAccountMe } from '@/domain/models/AuthEnterprise';
import { errorHandler } from '@/lib//ErrorHandler';
import { getClient } from '@/lib/restClient';
import { AuthEnterpriseService } from '@/services/AuthEnterprise';

interface ReturnManagerAccountMe {
  managerAccountMe?: ManagerAccountMe;
  isLoading: boolean;
  isError: Error | null;
}

export const useManagerAccountMe = (): ReturnManagerAccountMe => {
  const authEnterpriseService = new AuthEnterpriseService(getClient());

  const {
    data: managerAccountMe,
    error,
    isLoading,
  } = useQuery<ManagerAccountMe, Error>('managerAccountMe', () =>
    authEnterpriseService.me().catch((error: Error) => errorHandler({ error }))
  );

  return {
    managerAccountMe,
    isLoading,
    isError: error,
  };
};
